var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{mask:url(#mask-2_00000013877590320750258170000003281128350860576173_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#DB7940;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_x2F_arrow_x2F_right"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.5,
    y: -0.1,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.5,
    y: -0.1,
    width: 20,
    height: 20,
    id: "mask-2_00000013877590320750258170000003281128350860576173_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000036240951162612920520000008903347706890253442_",
    className: "st1",
    d: "M15.1,16.6c0.4,0.4,0.4,1,0,1.4 c-0.4,0.4-0.9,0.4-1.3,0.1l-0.1-0.1l-7.6-7.5C5.7,10.2,5.7,9.7,6,9.3l0.1-0.1l7.6-7.5c0.4-0.4,1-0.4,1.4,0 c0.4,0.4,0.4,0.9,0.1,1.3l-0.1,0.1L8.2,9.9L15.1,16.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour_x2F_ambient_x2F_sophia"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0.5,
    y: -0.1,
    className: "st3",
    width: 20,
    height: 20
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.3c10065adf00da5c0bb50d4af3aaeb96.svg";
export { ForwardRef as ReactComponent };